import { useRouter } from 'next/router'
import { Dispatch } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { CompatibleLink } from 'src/components/CompatibleLink/CompatibleLink'
import { pop } from 'src/store/actions/origin'
import { AppState } from 'src/store/types'

import { useOriginalTopicSubTopic } from './UseOriginalTopicSubTopic'

interface Props {
  companyName?: string
  isFromAutosuggest?: boolean
}

export const SolutionBreadcrumb: React.FC<Props> = ({ isFromAutosuggest, companyName }) => {
  const originInfo = useSelector((state: AppState) => state.originInfo)
  const lastOrigin = originInfo.lastOrigin || null
  const prevPath = lastOrigin?.originPath || ''
  const router = useRouter()

  const slugs = useOriginalTopicSubTopic(prevPath)

  let backSolutionName: string | undefined = ''
  if (prevPath.startsWith('/vendors') || prevPath.startsWith('/alsps') || prevPath.startsWith('/consultants')) {
    backSolutionName = lastOrigin?.solutionName
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dispatch: Dispatch<any> = useDispatch()
  function popOrigin() {
    const action = pop()
    dispatch(action)
  }

  return (
    <div className="!max-w-[1100px] flex flex-row w-full mt-[20px] mb-[10px] m-auto">
      <div>
        {prevPath === '' && isFromAutosuggest && router.pathname.indexOf('companies') && (
          <CompatibleLink className="font-primary font-bold text-[15px] text-textdark" href={'/'} onClick={popOrigin}>
            <span className="me-[10px]">&lt;</span>
            Back to Search Results
          </CompatibleLink>
        )}

        {prevPath === '' && !isFromAutosuggest && router.pathname.indexOf('companies') && companyName && (
          <div className="font-primary font-bold text-[15px] text-textdark">{companyName}</div>
        )}

        {prevPath.startsWith('/search') ? (
          <CompatibleLink
            className="font-primary font-bold text-[15px] text-textdark"
            href={prevPath}
            onClick={popOrigin}
          >
            <span className="me-[10px]">&lt;</span>
            Back to Search Results
          </CompatibleLink>
        ) : null}
      </div>
      <div>
        {prevPath.startsWith('/topics') && slugs.topicSlug && !slugs.subTopicSlug ? (
          <div>
            <CompatibleLink
              className="font-primary font-bold text-[15px] text-textdark"
              href={`${router.basePath}/topics/${slugs.topicSlug}`}
              onClick={popOrigin}
            >
              <span className="me-[10px]">&lt;</span>
              <span>Back to {lastOrigin?.topicName}</span>
            </CompatibleLink>
          </div>
        ) : null}

        {prevPath.startsWith('/companies') && slugs.companySlug ? (
          <div>
            <CompatibleLink
              className="font-primary font-bold text-[15px] text-textdark"
              href={prevPath}
              onClick={popOrigin}
            >
              <span className="me-[10px]">&lt;</span>
              <span>Back to {lastOrigin?.companyName}</span>
            </CompatibleLink>
          </div>
        ) : null}
      </div>
      <div>
        {prevPath.startsWith('/topics') && slugs.topicSlug && slugs.subTopicSlug ? (
          <div>
            <span className="font-primary font-bold text-[15px] text-textdark mx-[10px]">&lt;</span>
            <CompatibleLink
              className="font-primary font-bold text-[15px] text-textdark"
              href={`${router.basePath}/topics/${slugs.topicSlug}`}
              onClick={popOrigin}
            >
              {lastOrigin?.topicName}
            </CompatibleLink>
            <CompatibleLink
              className="font-primary font-bold text-[15px] text-textdark"
              href={prevPath}
              onClick={popOrigin}
            >
              {lastOrigin?.subTopicName}
            </CompatibleLink>
          </div>
        ) : null}
      </div>
      <div>
        {prevPath.startsWith('/vendors') || prevPath.startsWith('/alsps') || prevPath.startsWith('/consultants') ? (
          <CompatibleLink
            className="font-primary font-bold text-[15px] text-textdark"
            href={prevPath}
            onClick={popOrigin}
          >
            <span className="me-[10px]">&lt;</span>
            <span>Back to {backSolutionName}</span>
          </CompatibleLink>
        ) : (
          <></>
        )}
      </div>
      <div>
        {prevPath === '/' ? (
          <CompatibleLink
            className="font-primary font-bold text-[15px] text-textdark"
            href={prevPath}
            onClick={popOrigin}
          >
            <span className="me-[10px]">&lt;</span>
            <span>Back to Home</span>
          </CompatibleLink>
        ) : null}
      </div>
    </div>
  )
}
